export default {
  /**
   * Determine whether a given policy number is a speciality lines policy.
   * Known Speciality Lines Policy Formats: SFM\d{6} HD\d{7} LX\d{7} LS\d{7} GLX\d{6}
   * @param {*} policyNumber the policy number to check
   */
  isSpecialityLinesPolicy(policyNumber) {
    return (/^SFM\d{6}$/.test(policyNumber) ||
      /^HD\d{7}$/.test(policyNumber) ||
      /^LX\d{7}$/.test(policyNumber) ||
      /^LS\d{7}$/.test(policyNumber) ||
      /^GLX\d{6}$/.test(policyNumber));
  },

   /**
   * Determine whether a given policy number is a Florida policy.
   * Florida Policy Formats: P\d{9}
   */
  isFloridaPolicy(policyNumber) {
    return (/P\d{9}/g.test(policyNumber));
  },

  /**
   * Determine whether a given policy number is a Missouri policy.
   * MO policy Formats: Q\d{9}
   */
  isMissouriPolicy(policyNumber) {
    return (/Q\d{9}/g.test(policyNumber));
  }
};



// WEBPACK FOOTER //
// ./src/services/RejectedPoliciesService.js